import dayjs from 'dayjs';

export const getDateRange = (year: number, month?: number) => {
  if (month) {
    return {
      from: `${year}-${month}-01`,
      to: `${year}-${month}-${dayjs().endOf('month').format('DD')}`
    }
  }
  
  return {
    from: `${year}-01-01`,
    to: `${year}-12-31`
  }
};
